import Vue from 'vue'
import ApiClientsService from 'js/services/api/api-clients.js'
import TransactionsMixin from './account/_transactions_mixin.js'

import AccountMediaPanel from './account/_account_media_panel'
import TscMediaPanel from './tsc/_tsc_media_panel'
import ProductMediaPanel from './products/index'

import template from './index.pug'

// @vue/component
export default Vue.extend({
  name: 'balance-page',
  template: template(),

  components: {AccountMediaPanel, TscMediaPanel, ProductMediaPanel},

  mixins: [TransactionsMixin],

  data() {
    return {
      TSC_MEDIA_TYPE: '1',
      QR_MEDIA_TYPE: '2',
      
      ACCOUNT: 1,
      TSC: 2,
      PRODUCTS: 3,

      paymentMedias: [],
      mediaType: this.ACCOUNT,
      products: []
    }
  },

  computed: {
    ACCOUNT_TAB(){
      return {
        id: 1, 
        title: this.$t('balance.tabs.1')
      }
    },
    TSC_TAB() {
      return {
        id: 2, 
        title: this.$t('balance.tabs.2')
      }
    },
    PRODUCTS_TAB() {
      return {
        id: 3, 
        title:this.$t('balance.tabs.3')
      }
    },

    inAccountTab() {
      return this.mediaType === this.ACCOUNT
    },

    inTscTab() {
      return this.mediaType === this.TSC
    },

    inProductTab() {
      return this.mediaType === this.PRODUCTS
    },

    account() {
      const qr = this.paymentMedias.find(paymentMedia => paymentMedia.mediaType === this.QR_MEDIA_TYPE)

      // Meter rut al medio de pago. En el futuro la cuenta tendrá el rut y el saldo.
      if (qr) {
        qr.rutPassport = this.$currentAccount.rut
      }

      return qr
    },

    tscPaymentMedias() {
      return this.paymentMedias.filter(paymentMedia => paymentMedia.MediaType === this.TSC_MEDIA_TYPE)
    },

    mediaProfiles() {
      if (this.$administrativeArea?.media_profiles) {
        const mediaProfiles = {}
        this.$administrativeArea.media_profiles.forEach(mediaProfile => {
          mediaProfiles[mediaProfile.code] = mediaProfile.name
        })

        return mediaProfiles
      }

      return {}
    }
  },

  watch: {
    $currentAccount() {
      this.requestPaymentMedias()
    }
  },

  created() {
    this.requestPaymentMedias()
   
  },

  methods: {
    async requestPaymentMedias() {
      if (this.$currentAccount) {
        const params = {
          administrative_area_id: this.$currentAccount.administrative_area_id,
          rut: this.$currentAccount.rut
        }

        ApiClientsService.clientMediaInfo(params).then(response => {
          this.paymentMedias = _.map(response.data, media => ({
            ...media,
            balance: media.Balance,
            mediaCode: media.CardSerialNumber,
            mediaType: media.MediaType,
            profile: Number(media.Profile)
          }))
        })
      }
    },

    reloadView() {
      Vue.store.dispatch('loadCurrentUser').then(() => {
        this.requestPaymentMedias()
      })
    },

    changeTab(tabIndex) {
      
      this.mediaType = tabIndex
    },

    loadTabs() {
      if(this.$administrativeArea.config?.product_available){
        return [
          this.ACCOUNT_TAB, 
          this.TSC_TAB, 
          this.PRODUCTS_TAB
        ]
      }else{
        return [
          this.ACCOUNT_TAB, 
          this.TSC_TAB
        ]
      }
    }
  },

  mounted(){
    
    this.mediaType = this.ACCOUNT
    this.changeTab(this.ACCOUNT)

    setTimeout(
      () => {
        var tabs = this.loadTabs()
        var boton = document.getElementById(tabs[0].id);
        var left = this
        var title = tabs[0].title 
        // Agregar un listener para el evento focus
        boton.addEventListener('focus', function() {
          var textoescuchar=title
          left.escucharAudio(textoescuchar )
          
        });


        var boton1 = document.getElementById(tabs[1].id);
        var left = this
        var title1 = tabs[1].title 
        // Agregar un listener para el evento focus
        boton1.addEventListener('focus', function() {
          var textoescuchar=title1
          left.escucharAudio(textoescuchar )
          
        });
        var boton2 = document.getElementById(tabs[2].id);
        var left = this
        var title2 = tabs[2].title 
        // Agregar un listener para el evento focus
        boton2.addEventListener('focus', function() {
          var textoescuchar=title2
          left.escucharAudio(textoescuchar )
          
        });

        document.addEventListener('keydown', function(event) {
          
          if (event.key === 'Enter' || event.keyCode === 13) {
            
            var elementoEnFoco = document.activeElement;
            if(elementoEnFoco.id != null &&  elementoEnFoco.id != undefined && elementoEnFoco.id != '' ){ 
              
              left.changeTab(elementoEnFoco.id)
            }
            
          } 
        });

        
        
      },2000
    )
  }
})
